import { __assign } from 'tslib';
import React__default, { Children, useState, useLayoutEffect } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import StyledComparator, { classes } from './index.styled.js';

var Comparator = function PictureViewer(_a) {
    var maxItemsPerRow = _a.maxItemsPerRow, _b = _a.animateNewItems, animateNewItems = _b === void 0 ? true : _b, children = _a.children, className = _a.className, sx = _a.sx, style = _a.style, _c = _a.testId, testId = _c === void 0 ? "Comparator" : _c;
    var childrens = Children.toArray(children);
    var _d = useState(0), childresCount = _d[0], setChildrensCount = _d[1];
    var _e = useState(false), animate = _e[0], setAnimate = _e[1];
    useLayoutEffect(function () {
        if (childrens.length > childresCount) {
            setAnimate(true);
        }
        else if (childrens.length < childresCount) {
            setAnimate(false);
        }
        setChildrensCount(childrens.length);
    }, [childrens.length, childresCount]);
    var rows = Math.ceil(childrens.length / (maxItemsPerRow && maxItemsPerRow > 0 ? maxItemsPerRow : 3));
    var itemsPerRow = Math.ceil(childrens.length / rows);
    var flexList = [];
    var _loop_1 = function (i) {
        flexList.push(React__default.createElement(Box, { className: clsx(classes.flex), "data-testid": "".concat(testId, "-Row"), key: "row-".concat(i) }, childrens.slice(i, i + itemsPerRow).map(function (children, j) { return (React__default.createElement("div", { key: "item-".concat(i + j), className: clsx("ComparatorItem", classes.flexItem, animateNewItems && i + j === childrens.length - 1 && animate && classes.addAnimate) }, children)); })));
    };
    for (var i = 0; i < childrens.length; i += itemsPerRow) {
        _loop_1(i);
    }
    return (React__default.createElement(StyledComparator, { className: clsx("Comparator", className, classes.viewer), "data-testid": testId, sx: __assign({ gridTemplateRows: "repeat(".concat(rows, ", minmax(0, ").concat(100 / rows, "%))") }, sx), style: style }, flexList));
};

export { Comparator as default };
//# sourceMappingURL=index.js.map
